import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {OverlayRef} from "@angular/cdk/overlay";
import {VisitPlanCellModel} from "../../../models/visit-plan-cell.model";
import {FieldValueModel} from "../../../models/field-value.model";
import {VisitPlanCallModel} from "../../../models/visit-plan-call.model";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {NgForm} from "@angular/forms";
import {VisitPlanDatasourceEnum} from "../../../enums/visit-plan-datasource.enum";
import {TaskDetailedServiceTimeModel} from "../../../../tasks/models/task-detailed-service-time.model";
import * as moment from "moment-timezone";
import {isUndefined} from "lodash";
import * as _ from "lodash";
import {VisitPlanAccountFacadeService} from "../../services/visit-plan-account-facade.service";
import {Actions, ofType} from "@ngrx/effects";
import {VisitPlanAccountAPiActions} from "../../state/visit-plan-account-state/visit-plan-account.actions";
import {VisitPlanHttpService} from "../../services/visit-plan-http.service";
import {BehaviorSubject, combineLatest, finalize, Observable, Subject, Subscription} from "rxjs";
import {distinctUntilChanged, map} from "rxjs/operators";
import {VisitPlanAccountCallAnalysisModel, VisitPlanAccountSlotAnalysisModel} from "../../../models/visit-plan-account-analysis.model";
import {VisitPlanFacadeService} from "../../services/visit-plan-facade.service";
import {
  VisitPlanExternalAssignRequests
} from "../../../models/visit-plan-create-external-resource-holders-payload.model";
import {VisitScheduleResourceHolderExt} from "../../../models/visit-schedule-resource-holder-ext.model";
import {VisitScheduleDayModel} from "../../../models/visit-schedule-day.model";
import {isVisitScheduleDayDispatchedByDate} from "../../../models/visit-schedule-day.functions";
import {
  VisitPlanScheduleResourceSelectListComponent
} from "../visit-plan-schedule-resource-select-list/visit-plan-schedule-resource-select-list.component";

interface CellEditDialogDataInput {
  visitPlanCell: VisitPlanCellModel;
  visitPlanCellTracker?: VisitPlanCellModel;
  programTypeAliasMap: { [key: string]: string };
  dateRange: { from: number, to: number };
  isDeliveryEdit: boolean;
  visitPlan?: VisitPlanModel;
  isServiceTimeFromMLPrediction: boolean;
  visitPlanAccountCellAnalysis?: VisitPlanAccountSlotAnalysisModel;
  visitScheduleDays?: VisitScheduleDayModel[];
  isDayDispatched?: boolean;
  initialEditCallId?: string; // opens the dialog directly on this call's edit tab
}

require('./cell-edit-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-cell-edit-dialog',
  templateUrl: './cell-edit-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellEditDialogComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter<any>();
  @Output() serviceTimeUpdated = new EventEmitter<number>();
  @Output() onLockCallChange = new EventEmitter<{ id: string, locked: boolean }>();

  @ViewChild(VisitPlanScheduleResourceSelectListComponent) resourceSelectList: VisitPlanScheduleResourceSelectListComponent;


  visitPlanCell: VisitPlanCellModel;
  programTypeAliasMap: { [key: string]: string };
  selectedTab: string;
  selectedCallsMap: { [key: string]: boolean };
  selectedIds: string[];
  public assignCallsDateRange: { from: number, to: number };
  isServiceTimeFromMLPrediction: boolean;
  public isOrderOrSell: boolean;

  currentEditingCallModel: {
    serviceTime: TaskDetailedServiceTimeModel;
    units: number;
    // subtasks: { id: string, name: string }[]
  };
  currentEditingCall: VisitPlanCallModel;
  visitPlanDatasources: typeof VisitPlanDatasourceEnum = VisitPlanDatasourceEnum;
  public currentEditCallMinSerivceTime: number;
  public moveDayOptions: { dayName: string; date: string; timestamp: number; isDispatched: boolean }[] = [];
  public selectedMoveDayOption: { dayName: string; date: string; timestamp: number; isDispatched: boolean };
  public deliveryUnits: number;
  public selectedResourceId: string;
  public externalAssignPayload: VisitPlanExternalAssignRequests;
  public isAssigningCalls: boolean = false;
  public visitPlan: VisitPlanModel;
  private assignCallsActionsSub: Subscription;

  public isMlServiceTimeMenuOpen: boolean = false;

  visitCallServiceTimePredictionsMap$ = new BehaviorSubject<{ [key: string]: number }>({});
  mlServiceTimeSuggestion$: Observable<number | undefined> | null = null;
  private sub: Subscription;
  public callAnalysisMap: { [key: string]: VisitPlanAccountCallAnalysisModel } = {};
  public enableUnassignedAction: boolean = false;
  public isLoading: boolean = false;
  public isDayDispatched: boolean = false;

  constructor(
    @Inject(PANEL_DATA) public data: CellEditDialogDataInput,
    @Inject(OverlayRef) private overlayRef: OverlayRef,
    @Inject('splitService') private splitService,
    @Inject(VisitPlanHttpService) private visitPlanHttpService: VisitPlanHttpService,
    @Inject(VisitPlanFacadeService) private visitPlanFacadeService: VisitPlanFacadeService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(VisitPlanAccountFacadeService) private visitPlanAccountFacadeService: VisitPlanAccountFacadeService,
    @Inject(Actions) private actions$: Actions,
    @Inject('bringozToastService') private bringozToastService: any,
    @Inject('schedulingProjectAlertsService') private schedulingProjectAlertsService,
    @Inject('analyticsService') private analyticsService
  ) {
  }

  ngOnDestroy() {
    this.assignCallsActionsSub?.unsubscribe();
    this.isMlServiceTimeMenuOpen = false;
    this.sub?.unsubscribe();
  }

  ngOnInit() {

    if (!!this.data.visitPlanCellTracker) {
      this.visitPlanCell = {...this.data.visitPlanCellTracker}
    } else {
      this.visitPlanCell = {...this.data.visitPlanCell}
    }

    if (!!this.data.visitPlan) {
      this.visitPlan = this.data.visitPlan;
    }

    if (this.data.isDeliveryEdit) {
      this.deliveryUnits = this.getFieldValue(this.visitPlanCell.deliveryDetails.deliveryUnits);
      this.selectedTab = 'deliveryEdit';
    } else {
      this.selectedTab = 'callsList';
    }
    this.programTypeAliasMap = this.data.programTypeAliasMap;

    this.selectedCallsMap = {};
    this.visitPlanCell.calls.forEach(call => {
      this.selectedCallsMap[call.id] = false;
    })

    this.selectedIds = [];
    this.isDayDispatched = !!this.data.isDayDispatched;
    this.moveDayOptions = this.generateTableDays(this.data.dateRange)
      .filter(option => !moment(option.timestamp).isSame(this.visitPlanCell.date, 'day'))
      .map(option => ({
        ...option,
        isDispatched: isVisitScheduleDayDispatchedByDate(this.data.visitScheduleDays, option.timestamp)
      }));

    // Initialize call analysis map
    this.callAnalysisMap = {};
    this.data.visitPlanAccountCellAnalysis?.calls?.forEach((callAnalysis) => {
      this.callAnalysisMap[callAnalysis.callId] = callAnalysis;
    });

    this.isServiceTimeFromMLPrediction = this.data.isServiceTimeFromMLPrediction;

    const initialEditCall = this.visitPlanCell.calls.find(call => call.id === this.data.initialEditCallId);
    if (initialEditCall) {
      this.onEditCall(initialEditCall);
    }

    this.listenToAssignCallsActions();

    if (this.selectedTab === 'assignCalls') {
      setTimeout(() => {
        this.overlayRef.updatePosition();
      })
    }
  }

  getPredictions(isPopoverOpen: boolean) {
    if (!isPopoverOpen) {
      this.isLoading = true;

      this.sub = this.visitPlanHttpService
        .getServiceTimePrediction(this.visitPlanCell.visitPlanId, {
          accountId: this.visitPlanCell.accountId,
          date: this.visitPlanCell.date
        })
        .subscribe({
          next: (prediction) => {
            this.visitCallServiceTimePredictionsMap$.next(prediction.visitCallIdToPredictionMap);
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Error fetching service time prediction:', error);
            this.isLoading = false;
          }
        });
    }
  }

  onAddCall() {
    this.onClose.emit({onAddCall: true});
  }


  onMoveDay() {
    this.selectedTab = 'moveDay';

    setTimeout(() => {
      this.overlayRef.updatePosition();
    })
  }

  onAssignCalls() {
    if (!this.data.visitPlan || !this.selectedIds.length || this.visitPlan?.hasNotSyncedChanges) return;

    // Set date range to be just the cell's date (one day)
    const cellDate = moment.tz(this.visitPlanCell.date, this.visitPlan.zoneId);
    this.assignCallsDateRange = {
      from: cellDate.startOf('day').valueOf(),
      to: cellDate.endOf('day').valueOf()
    };

    this.selectedTab = 'assignCalls';
    this.selectedResourceId = null;
    this.externalAssignPayload = null;

    setTimeout(() => {
      this.overlayRef.updatePosition();
    })
  }

  onUnAssignCalls() {
    if (!this.data.visitPlan || !this.selectedIds.length || this.visitPlan?.hasNotSyncedChanges) return;

    const selectedCalls = Object.keys(this.selectedCallsMap).filter(key => this.selectedCallsMap[key]);

    const grouped = selectedCalls.reduce<Record<string, string[]>>((acc, id) => {
      const item = this.callAnalysisMap[id];
      if (!item) return acc;

      if (!acc[item.routeId]) {
        acc[item.routeId] = [];
      }

      acc[item.routeId].push(item.jobId);
      return acc;
    }, {});

    const payload = Object.entries(grouped).map(([routeId, jobIds]) => ({
      id: routeId,
      remove: jobIds
    }));

    this.onClose.emit({unassignedPayload: payload})

  }

  onSelectResource(resourceId: string) {
    this.selectedResourceId = resourceId;
    this.externalAssignPayload = null;
    this.cdr.detectChanges();
  }

  onExternalResourceSelected(externalAssignPayload: VisitPlanExternalAssignRequests) {
    this.externalAssignPayload = externalAssignPayload;
    this.selectedResourceId = null;
    this.cdr.detectChanges();
  }

  onDeleteCalls() {
    // const deletedCallIds = Object.keys(this.selectedCallsMap).filter(callId => this.selectedCallsMap[callId]);
    //
    // if (!deletedCallIds!.length) return;

    this.onClose.emit({deletedCallIds: this.selectedIds});
  }

  onDeleteCall(callId: string) {
    this.onClose.emit({deletedCallIds: [callId]});
  }

  onSelectCall(callId: string) {
    this.selectedCallsMap[callId] = !this.selectedCallsMap[callId];
    if (this.selectedCallsMap[callId]) {
      this.selectedIds.push(callId);
    } else {
      const selectedCallIdIndex = this.selectedIds.findIndex(id => id === callId);
      this.selectedIds.splice(selectedCallIdIndex, 1);
    }

    this.enableUnassignedAction = Object.keys(this.selectedCallsMap).some((id) => {
      if (!this.selectedCallsMap[id]) return false;

      const item = this.callAnalysisMap[id];
      return !!item?.routeId;
    });
  }

  get hasSelectedLockedCall(): boolean {
    return this.selectedIds.some(callId => {
      const call = this.visitPlanCell.calls?.find(c => c.id === callId);
      return call?.locked;
    });
  }

  onToggleLockCall(call: VisitPlanCallModel) {
    call.locked = !call.locked;
    this.onLockCallChange.emit({ id: call.id, locked: call.locked });
  }

  onEditCall(call: VisitPlanCallModel) {
    this.analyticsService.trackEvent('Visit Plan Actions', 'visit_plan_cell_dialog_edit_call', call.id);
    this.selectedTab = 'callEdit';
    this.currentEditingCall = {...call};

    const callType = this.programTypeAliasMap[this.getFieldValue(call.programType)];
    this.isOrderOrSell = callType === 'O' || callType === 'S';

    const serviceTime = this.getFieldValue(call.destination?.serviceTime) as TaskDetailedServiceTimeModel;

    this.currentEditingCallModel = {
      units: this.getFieldValue(call.units),
      serviceTime: serviceTime ? {...serviceTime} : {
        workTime: 0,
        subTasksTime: 0,
        entryTime: 0,
        exitTime: 0,
        packagesTime: 0,
        generatedTotalTime: 0
      },
      // subtasks: this.getFieldValue(call.destination.subtasks)
      // predictionServiceTime: this.visitCallServiceTimePredictionsMap[call.id]
    };

    // this.mlServiceTimeSuggestion$ = this.visitCallServiceTimePredictionsMap$
    //   .pipe(map(predictions => predictions[call.id]));

    this.mlServiceTimeSuggestion$ = this.visitCallServiceTimePredictionsMap$.pipe(
      map(mapObj => mapObj ? mapObj[call.id] : undefined),
      distinctUntilChanged()
    );

    this.currentEditCallMinSerivceTime = ((this.currentEditingCallModel.serviceTime.generatedTotalTime || 0) - (this.currentEditingCallModel.serviceTime.workTime || 0)) / 60000;

    setTimeout(() => {
      this.overlayRef.updatePosition();
    })
  }

  // get selectedIds(): string[] {
  //   return this.currentEditingCallModel?.subtasks?.map(t => t.id) || [];
  // }

  onChangeSubTasks(ids, subtaskTemplates) {

  }

  onAddDelivery() {
    if (!this.visitPlanCell.deliveryDetails.isDeliveryDay?.adjusted) {
      this.visitPlanCell.deliveryDetails.isDeliveryDay.adjusted = {};
    }
    this.visitPlanCell.deliveryDetails.isDeliveryDay.hasPendingChanges = true;
    this.visitPlanCell.deliveryDetails.isDeliveryDay.adjusted.value = true;
    this.visitPlanCell.deliveryDetails.isDeliveryDay.adjusted.source = this.visitPlanDatasources.Manual;

    this.onClose.emit({visitPlanCell: this.visitPlanCell})
  }

  onRemoveDelivery() {
    if (!this.visitPlanCell.deliveryDetails.isDeliveryDay?.adjusted) {
      this.visitPlanCell.deliveryDetails.isDeliveryDay.adjusted = {};
    }
    this.visitPlanCell.deliveryDetails.isDeliveryDay.hasPendingChanges = true;
    this.visitPlanCell.deliveryDetails.isDeliveryDay.adjusted.value = false;
    this.visitPlanCell.deliveryDetails.isDeliveryDay.adjusted.source = this.visitPlanDatasources.Manual;

    if (!this.visitPlanCell.deliveryDetails.deliveryUnits?.adjusted) {
      this.visitPlanCell.deliveryDetails.deliveryUnits.adjusted = {};
    }

    this.visitPlanCell.deliveryDetails.deliveryUnits.hasPendingChanges = true;
    this.visitPlanCell.deliveryDetails.deliveryUnits.adjusted.value = 0;
    this.visitPlanCell.deliveryDetails.deliveryUnits.adjusted.source = this.visitPlanDatasources.Manual;

    this.onClose.emit({visitPlanCell: this.visitPlanCell});
  }

  onCancelCallEdit() {
    if (this.data.initialEditCallId) {
      this.onClose.emit();
      return;
    }

    this.currentEditingCallModel = null;
    this.selectedResourceId = null;
    this.externalAssignPayload = null;
    this.isOrderOrSell = undefined;
    this.selectedTab = 'callsList';

    setTimeout(() => {
      this.overlayRef.updatePosition();
    })
  }

  onChangeMoveDay(value) {
    const option = this.moveDayOptions.find(day => day.timestamp === value);
    if (option?.isDispatched) return;

    this.selectedMoveDayOption = option;
  }

  get blockedActionTooltipKey(): string {
    return this.isDayDispatched ? 'VISIT_SCHEDULE_TOOLTIPS.ACTION_BLOCKED_CALL_DISPATCHED' : '';
  }

  onAdvancedEdit() {
    this.onClose.emit({advanceEdit: true, call: this.currentEditingCall, visitPlanCell: this.visitPlanCell});
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    } else {
      if (this.selectedTab === 'moveDay') {
        const updateCallTimeWindowList = [];
        for (const [key, value] of Object.entries(this.selectedCallsMap)) {
          if (value) {
            const call = this.visitPlanCell.calls.find((call) => call.id === key);
            const previousNotBefore = moment.tz(this.getFieldValue(call.destination.notBefore), this.visitPlan.zoneId);
            const updatedNotBefore = moment.tz(this.selectedMoveDayOption.timestamp, this.visitPlan.zoneId).startOf('day')
              .add(previousNotBefore.hours(), 'hours')
              .add(previousNotBefore.minutes(), 'minutes')
              .add(previousNotBefore.seconds(), 'seconds');

            const previousNotAfter = moment.tz(this.getFieldValue(call.destination.notAfter), this.visitPlan.zoneId);
            const updatedNotAfter = moment.tz(this.selectedMoveDayOption.timestamp, this.visitPlan.zoneId).startOf('day')
              .add(previousNotAfter.hours(), 'hours')
              .add(previousNotAfter.minutes(), 'minutes')
              .add(previousNotAfter.seconds(), 'seconds');

            updateCallTimeWindowList.push({
              callId: key,
              notBefore: moment(updatedNotBefore).valueOf(),
              notAfter: moment(updatedNotAfter).valueOf()
            })
          }
        }

        this.onClose.emit({updateCallTimeWindowList: updateCallTimeWindowList})

      } else if (this.selectedTab === 'callEdit' && this.currentEditingCallModel) {
        const callIndex = this.visitPlanCell.calls.findIndex((call) => call.id === this.currentEditingCall.id);

        if (this.getFieldValue(this.currentEditingCall.units) !== this.currentEditingCallModel.units) {
          if (!this.currentEditingCall.units) {
            this.currentEditingCall.units = {}
          }

          if (!this.currentEditingCall.units.adjusted) {
            this.currentEditingCall.units.adjusted = {};
          }
          this.currentEditingCall.units.hasPendingChanges = true;
          this.currentEditingCall.units.adjusted.value = this.currentEditingCallModel.units;
          this.currentEditingCall.units.adjusted.source = this.visitPlanDatasources.Manual;
        }

        // if (this.getFieldValue(this.currentEditingCall.destination.serviceTime)?.generatedTotalTime !== this.currentEditingCallModel.serviceTime.generatedTotalTime) {
        //
        //   if (!this.currentEditingCall.destination.serviceTime) {
        //     this.currentEditingCall.destination.serviceTime = {}
        //   }
        //
        //   if (!this.currentEditingCall.destination.serviceTime?.adjusted) {
        //     this.currentEditingCall.destination.serviceTime.adjusted = {};
        //   }
        //
        //   this.currentEditingCall.destination.serviceTime.hasPendingChanges = true;
        //
        //   this.currentEditingCall.destination.serviceTime.adjusted.value =
        //     {
        //       ...this.getFieldValue(this.currentEditingCall.destination.serviceTime),
        //       workTime: (this.getFieldValue(this.currentEditingCall.destination.serviceTime)?.workTime || 0) + ((this.currentEditingCallModel.serviceTime.generatedTotalTime || 0) - (this.getFieldValue(this.currentEditingCall.destination.serviceTime)?.generatedTotalTime || 0))
        //     };
        //   this.currentEditingCall.destination.serviceTime.adjusted.source = this.visitPlanDatasources.Manual;
        // }

        if (this.getFieldValue(this.currentEditingCall.destination.serviceTime)?.workTime !== this.currentEditingCallModel.serviceTime.workTime) {

          if (!this.currentEditingCall.destination.serviceTime) {
            this.currentEditingCall.destination.serviceTime = {}
          }

          if (!this.currentEditingCall.destination.serviceTime?.adjusted) {
            this.currentEditingCall.destination.serviceTime.adjusted = {};
          }

          this.currentEditingCall.destination.serviceTime.hasPendingChanges = true;

          this.currentEditingCall.destination.serviceTime.adjusted.value =
            {
              ...this.getFieldValue(this.currentEditingCall.destination.serviceTime),
              workTime: this.currentEditingCallModel.serviceTime.workTime
            };
          this.currentEditingCall.destination.serviceTime.adjusted.source = this.visitPlanDatasources.Manual;
        }

        this.visitPlanCell.calls.splice(callIndex, 1, this.currentEditingCall);
        this.onClose.emit({visitPlanCell: this.visitPlanCell})
      } else if (this.selectedTab === 'deliveryEdit') {
        if (this.getFieldValue(this.visitPlanCell.deliveryDetails.deliveryUnits) !== this.deliveryUnits) {
          if (!this.visitPlanCell.deliveryDetails.deliveryUnits?.adjusted) {
            this.visitPlanCell.deliveryDetails.deliveryUnits.adjusted = {};
          }
          this.visitPlanCell.deliveryDetails.deliveryUnits.hasPendingChanges = true;
          this.visitPlanCell.deliveryDetails.deliveryUnits.adjusted.value = this.deliveryUnits;
          this.visitPlanCell.deliveryDetails.deliveryUnits.adjusted.source = this.visitPlanDatasources.Manual;
        }

        this.onClose.emit({visitPlanCell: this.visitPlanCell})
      } else if (this.selectedTab === 'assignCalls' && this.selectedResourceId) {
        if (!this.data.visitPlan || !this.selectedIds.length) return;

        const allocationSkills = this.resourceSelectList?.options?.find(o => o.resource.id === this.selectedResourceId)?.resource?.allocationSkills;
        if (this._hasSkillMismatch(this.selectedIds, allocationSkills)) {
          this.schedulingProjectAlertsService.noMatchingSkillsInfo();
          return;
        }

        this.isAssigningCalls = true;
        this.cdr.detectChanges();

        this.visitPlanAccountFacadeService.assignCallsToResource(
                  this.data.visitPlan.id,
                  this.data.visitPlan.scheduleId,
                  {
                    resourceId: this.selectedResourceId,
            callIds: [...this.selectedIds],
            cellId: this.visitPlanCell.id,
            accountId: this.visitPlanCell.accountId,
            dateRange: this.assignCallsDateRange
          }
        );
      }
      else if (this.selectedTab === 'assignCalls' && this.externalAssignPayload) {
        if (!this.data.visitPlan || !this._isValidExternalAssignPayload(this.externalAssignPayload)) return;

        this.isAssigningCalls = true;
        this.cdr.detectChanges();

        this.visitPlanFacadeService.importExternalAgentsResourceHoldersDesignated(this.data.visitPlan.id, this.data.visitPlan.scheduleId, [this.externalAssignPayload])
          .subscribe({
            next: (resourceHolders: VisitScheduleResourceHolderExt[]) => {
              const resourceHolder = resourceHolders[0];
              this.visitPlanAccountFacadeService.assignCallsToResource(
                this.data.visitPlan.id,
                this.data.visitPlan.scheduleId,
                {
                  resourceId: resourceHolder.id,
                  callIds: [...this.selectedIds],
                  cellId: this.visitPlanCell.id,
                  accountId: this.visitPlanCell.accountId,
                  dateRange: this.assignCallsDateRange
                }
              );
            },
            error: (err) => {
              this.schedulingProjectAlertsService.importAgentsError();
            }
          })
      }

    }
  }

  onCancel() {
    this.onClose.emit()
  }

  get isFormDisabled(): boolean {
    if (this.selectedTab === 'moveDay') {
      return !this.selectedMoveDayOption;
    } else if (this.selectedTab === 'assignCalls') {
      if (this.visitPlan?.hasNotSyncedChanges) {
        return true;
      }
      if (this.selectedResourceId) {
        return false;
      }
      return !this._isValidExternalAssignPayload(this.externalAssignPayload);
    }
    return false;
  }

  private _hasSkillMismatch(callIds: string[], allocationSkills: any): boolean {
    const selectedCalls = this.visitPlanCell.calls.filter(c => callIds.includes(c.id));
    const callSkills = _.flatMap(selectedCalls, c => this.getFieldValue(c.skills) || []);
    return !!(allocationSkills && _.difference(callSkills, allocationSkills).length);
  }

  private _isValidExternalAssignPayload(payload: VisitPlanExternalAssignRequests): boolean {
    if (!payload?.agentId || !payload.startTime || !payload.endTime) {
      return false;
    }
    return payload.endTime > payload.startTime;
  }

  getFieldValue<T>(field: FieldValueModel<T>): T | undefined {
    if (!field) {
      return undefined;
    } else if (isUndefined(field.adjusted?.value)) {
      return field.initial?.value
    } else {
      return field.adjusted?.value
    }
  }

  private generateTableDays(dateRange: { from: number, to: number }) {
    const days: { dayName: string; date: string; timestamp: number }[] = [];

    const format = this.splitService.getDateAndTimeConfig(false).date;

    let current = moment.tz(dateRange.from, this.visitPlan.zoneId).startOf("day");
    const end = moment.tz(dateRange.to, this.visitPlan.zoneId).startOf("day");

    while (current.isSameOrBefore(end, "day")) {
      days.push({
        dayName: current.format("dddd"),
        date: current.format(format),
        timestamp: current.startOf('day').valueOf()
      });

      current = current.clone().add(1, "day");
    }

    return days;
  }

  toggleMlServiceTimeMenu(event: Event) {
    event.stopPropagation();
    this.isMlServiceTimeMenuOpen = !this.isMlServiceTimeMenuOpen;
  }

  closeMlServiceTimeMenu() {
    this.isMlServiceTimeMenuOpen = false;
  }

  calcServiceTimeFromHoursToMinutes(value: number) {
    return Math.round(value / 60000);
  }

  formatMinutesToHHMM(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  updateServiceTimeFromMlSuggestion(value: number) {
    this.currentEditingCallModel.serviceTime.workTime = value
    this.closeMlServiceTimeMenu();
  }

  private listenToAssignCallsActions() {
    this.assignCallsActionsSub = this.actions$.pipe(
      ofType(
        VisitPlanAccountAPiActions.assignCallsToResourceSuccess,
        VisitPlanAccountAPiActions.assignCallsToResourceFailure
      )
    ).subscribe(action => {
      if (!this.isAssigningCalls) {
        return;
      }

      const isSuccess = action.type === VisitPlanAccountAPiActions.assignCallsToResourceSuccess.type;

      const targetCellId = isSuccess
        ? (action as ReturnType<typeof VisitPlanAccountAPiActions.assignCallsToResourceSuccess>).visitPlanCell.id
        : (action as ReturnType<typeof VisitPlanAccountAPiActions.assignCallsToResourceFailure>).cellId;

      if (targetCellId !== this.visitPlanCell.id) {
        return;
      }

      this.isAssigningCalls = false;
      this.cdr.detectChanges();

      if (isSuccess) {
        this.onClose.emit({
          assignedCallsToResource: {
            callIds: [...this.selectedIds],
            resourceId: this.selectedResourceId,
            cellId: this.visitPlanCell.id,
            accountId: this.visitPlanCell.accountId,
            dateRange: this.assignCallsDateRange
          }
        });
    } else {
        const failureAction = action as ReturnType<typeof VisitPlanAccountAPiActions.assignCallsToResourceFailure>;
        const message = failureAction.userMessage || 'Unable to assign calls. Please try again.';
        this.bringozToastService?.error({
          body: message
        });
      }
    });
  }

}
